import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c479c2c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"position":"fixed","top":"0","left":"0","width":"100%","height":"100%","background-color":"rgba(255, 255, 255, 0.95)","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","z-index":"9999"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-spin pi-spinner",
  style: {"font-size":"3rem","color":"#eb9251"}
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"1rem","font-size":"1.2rem","color":"#4b5563"} }, "読み込み中...", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "booking ml-3 mr-3" }
const _hoisted_6 = { class: "main-content-page-title font-normal mt-3 mb-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "booking_wrapper" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "booking_sidebar" }

import { onBeforeMount, ref, provide, inject, computed, watch } from "vue";
import { useStore } from "vuex";
import { templateRef } from "@vueuse/core";

// コンポーネントのインポート
import StaffBookingCalendar from "./components/calendar/index.vue";
import RoomBookingCalendar from "./components/calendar/room/index.vue";
import BookingSidebar from "./booking-sidebar.vue";
import ListBookingHistory from "./components/list/list-booking-history.vue";

// ユーティリティライブラリのインポート
import moment from "moment";
import * as _ from "lodash";
import { set, get, AnyFn, useArrayMap } from "@vueuse/core";

// 型定義のインポート
import {
  ApiBookingIndexReq,
  ApiBookingIndexRes,
  ApiMenuIndexRes,
  ApiStaffIndexRes,
  ApiStaffsReq,
  IBooking,
  IBookingEventFn,
  IBookingEventInput,
  IBookingEventInputExtendedProps,
  IBookingResourceEvent,
  IBookingStaffResource,
  IMenu,
} from "@/clinic/typings";

// 列挙型のインポート
import {
  BookingActionEnum,
  BookingResourceFieldNameEnum,
  BookingViewPageTypeEnum,
  BookingViewTypeEnum,
} from "@/clinic/typings/enums/booking";

// FullCalendar関連のインポート
import { EventClickArg, EventInput } from "@fullcalendar/core";

// ダイアログコンポーネントのインポート
import DialogStaffTimeOff from "@/clinic/views/Booking/components/dialog/dialog-staff-time-off.vue";

// サービス層のインポート
import {
  BookingServices,
  MenuServices,
  StaffServices,
  WorkingTimeServices,
  BookingSettingService,
} from "@/clinic/services";

// 定数のインポート
import { CALENDER_RESOURCES_COUNT } from "@/clinic/typings/constants/booking";

// HTTP関連のインポート
import { AxiosResponse } from "axios";

// ユーティリティのインポート
import TimeUtils from "@/clinic/utils/time-utils";

// UIコンポーネントのインポート
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";

// ルーティング関連のインポート
import { useRoute, useRouter } from "vue-router";

// クリニック関連のインポート
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

/**
 * トースト通知用のインスタンス
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

// Vue関連のインポート
const toast = useToast();

/**
 * クリニックID
 */
const clinicId = ref(0);

/**
 * スタッフカレンダーのref
 */
const staffBookingCalendar = ref();

/**
 * 部屋カレンダーのref
 */
const roomBookingCalendar = ref();

/**
 * 予約枠の時間単位（例: 30分）
 */
const slotDuration = ref();

/**
 * カレンダーの表示タイプ（日/週）
 */
const viewType = ref<string>(BookingViewTypeEnum.Day);

/**
 * 予約リソース（スタッフまたはメニュー）
 */
const bookingResources = ref<IBookingStaffResource[] | IMenu[]>([]);

/**
 * カレンダーに表示するリソース数
 */
const bookingResourcesCount = ref<number>(CALENDER_RESOURCES_COUNT);

/**
 * カレンダーの開始日時
 */
const startTime = ref<Date>(new Date());

/**
 * 予約サイドバーのref
 */
const showBookingSidebar = ref<InstanceType<typeof BookingSidebar> | null>(null);

/**
 * 予約サイドバーを表示する
 * @param booking 予約情報
 * @param action アクション種別
 * @param event FullCalendarのイベント
 */
const onShowBookingSidebar = (booking: IBooking, action: BookingActionEnum, event: EventClickArg) =>
  get(showBookingSidebar)?.onShow(booking, action, event);

/**
 * 予約履歴リストのref
 */
const listBookingHistory = ref<InstanceType<typeof ListBookingHistory> | null>(null);

/**
 * 予約履歴リストをリロードする
 */
const onReloadListBookingHistory = () => get(listBookingHistory)?.onLoadBooking();

/**
 * 予約サイドバーを非表示にする
 */
const onHideBookingSidebar = () => get(showBookingSidebar)?.onClose();

/**
 * 現在表示中のページ種別
 */
const shownPage = ref<string>();

/**
 * クリニックIDをセットする（provide/inject経由）
 */
const setClinicId = async () => set(clinicId, await inject("clinicId"));

/**
 * カレンダーの開始日時をセット
 * @param startTimeX 開始日時
 */
const setStartTime = async (startTimeX: Date) => set(startTime, startTimeX);

/**
 * 予約リソースをセット
 * @param resources スタッフまたはメニュー配列
 */
const setBookingResources = async (resources: IBookingStaffResource[] | IMenu[]) => {
  set(bookingResources, resources);
  set(bookingResourcesCount, resources.length);
};
const route = useRoute();
const store = useStore();
const router = useRouter();

/**
 * スタッフ休暇ダイアログのref
 */
const dialogStaffTimeOff = templateRef<InstanceType<typeof DialogStaffTimeOff> | null>("dialogStaffTimeOff", null);

/**
 * スタッフ休暇ダイアログを表示する
 * @param data スタッフ情報（id, title）
 */
const showDialogStaffTimeOff = async (data: { id: string | number; title: string }) => {
  get(dialogStaffTimeOff)?.showDialog();
  get(dialogStaffTimeOff)?.setGeneralInfo(data);
  get(dialogStaffTimeOff)?.fetchStaffTimeOffs();
};

/**
 * カレンダーリソースを再取得する
 */
const refetchCalendarResources = () => get(staffBookingCalendar)?.refetchCalendarResources();

/**
 * クリニックIDパラメータを生成する
 * @returns スタッフ取得用パラメータ
 */
const clinicIdParams = async (): Promise<ApiStaffsReq> => ({
  clinic_id: get(await get(clinicId)) || store.getters["authClient/selectedClinic"].id,
  default_staff: "yes",
});

/**
 * スタッフ一覧を取得する
 */
const loadStaffs = async () => {
  const { data } = await StaffServices.getStaffs({ ...(await clinicIdParams()), for_calendar: "true" });
  const { staffs, meta } = get(data) as unknown as ApiStaffIndexRes;

  // バックエンドから返された clinic_id を設定
  if (meta && meta.clinic_id) {
    set(clinicId, meta.clinic_id);
  }

  const staffsData = staffs.sort((a: { id: number }, b: { id: number }) => a.id - b.id);
  setBookingResources(get(staffsData));
};

/**
 * スタッフのリソース情報を取得し、カレンダー用に整形する
 * @param date 対象日付
 * @param showFreeSpaceBooking 自由予約を表示するかどうか
 */
const loadStaffResources = async (date = moment(), showFreeSpaceBooking = true) => {
  await loadStaffs();

  const resources = get(bookingResources) as IBookingStaffResource[];

  // 基本設定からshow_free_spaceを取得
  const bookingSettings = store.state.bookingSetting?.bookingSetting;
  const isShowFreeSpaceEnabled = bookingSettings?.show_free_space !== false; // デフォルトtrue

  // 基本設定でOFFの場合は、チェックボックスの状態に関わらず非表示
  const shouldShowFreeSpace = isShowFreeSpaceEnabled && showFreeSpaceBooking;

  // クリニック情報とビュータイプを事前に取得（ループ外で1回のみ）
  const isClinicUnaffiliated = store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated;
  const clinicId = store.getters["authClient/selectedClinic"].id;
  const currentViewType = get(viewType);
  const isDayView = currentViewType == BookingViewTypeEnum.Day;
  const dateFormatted = moment(date).format("YYYY-MM-DD");

  const newResources = await Promise.all(
    resources?.map(async staff => {
      if (isClinicUnaffiliated) {
        // 提携外クリニックの場合、勤務時間を取得
        if (isDayView) {
          // 日表示の場合、利用可能な時間枠をフィルタリング
          const workingTime = await WorkingTimeServices.fetch(staff.id, clinicId, dateFormatted);
          const availableSlots = workingTime.data.value.filter((time: any) => time.status == true);
          if (availableSlots.length <= 0) {
            // 利用可能な時間枠がない場合、デフォルト設定
            staff["businessHours"] = [{ startTime: "0:0", endTime: "0:0", daysOfWeek: [0, 1, 2, 3, 4, 5, 6] }];
          } else {
            // 利用可能な時間枠をbusinessHoursに設定
            staff["businessHours"] = availableSlots.map((time: any) => {
              return {
                startTime: time.startTime,
                endTime: time.endTime,
                daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
              };
            });
          }
        } else {
          // 週表示の場合、休日情報を取得
          const daysOff = await StaffServices.getDayOffs(staff.id, {
            clinic_id: clinicId,
            start_date: dateFormatted,
            end_date: moment(date).add(6, "days").format("YYYY-MM-DD"),
          });
          // 休日以外の曜日を抽出
          const daysOffData = [0, 1, 2, 3, 4, 5, 6].filter(day => !(daysOff.data.value as any).includes(day));
          staff["businessHours"] = [
            {
              startTime: "0:0",
              endTime: "0:0",
              daysOfWeek: daysOffData,
            },
          ];
        }
      } else {
        // 提携クリニックの場合、デフォルト設定
        staff["businessHours"] = [{ startTime: "0:0", endTime: "0:0", daysOfWeek: [] }];
      }

      // 提携外クリニックの場合のみフリー予約を追加
      if (!isClinicUnaffiliated) {
        staff = addFreeBookingToResource(staff);
      }

      // フリースペースレーン（基本設定とチェックボックス両方を考慮）
      staff = addFreeSpaceToResource(staff, shouldShowFreeSpace);

      return staff;
    })
  );
  setBookingResources(newResources);
};

/**
 * スタッフリソースに「フリー予約」レーンを追加
 * @param staff スタッフ情報
 * @returns 加工後のスタッフ情報
 */
const addFreeBookingToResource = (staff: any) => {
  staff["children"] = [{ id: `${staff.id}fb`, title: "フリー予約", businessHours: staff["businessHours"] }];

  return staff;
};

/**
 * スタッフリソースに「自由予約」レーンを追加
 * @param staff スタッフ情報
 * @param showFreeSpace 自由予約を表示するかどうか
 * @returns 加工後のスタッフ情報
 */
const addFreeSpaceToResource = (staff: any, showFreeSpace = true) => {
  const existingChildren = staff["children"] || [];

  // 自由予約を表示する場合のみ追加
  if (showFreeSpace) {
    staff["children"] = [
      ...existingChildren,
      {
        id: `${staff.id}fs`, // fs = free space
        title: "自由予約",
        businessHours: staff["businessHours"],
      },
    ];
  } else {
    staff["children"] = existingChildren;
  }

  return staff;
};

/**
 * 予約イベントデータをFullCalendar用に変換
 * @param resource 予約データ
 * @returns FullCalendar用イベントデータ
 */
const onBookingEventTransformFn = (resource: EventInput): IBookingEventInput => {
  // 予約データから必要なプロパティを抽出
  const {
    id: reservationId,
    staff_id: staffId,
    customer_id: customerId,
    customer_name: customerName,
    customer_name_kana: customerNameKana,
    customer_status: customerStatus,
    customer_status_display_name: customerStatusDisplayName,
    medical_menu_id: medicalMenuId,
    medical_menu_category_id: medicalMenuCategoryId,
    menu_name: medicalMenuName,
    medical_option_ids: medicalOptionIds,
    start_time,
    end_time,
    total_amount: bookingTotalAmount,
    note,
    note_symptom,
    status,
    status_name: statusName,
    booking_request_status: bookingRequestStatus,
    special_notes: specialNotes,
    additional_fees: additionalFees,
    medical_option_names: medicalOptionNames,
    staff,
    medical_menu,
    additional_menus,
    booking_source: bookingSource,
    hotpepper_confirmed: hotpepperConfirmed,
    booking_request_id: bookingRequestId,
    room_id: roomId,
    room: room,
    is_free: isFree,
    is_free_space: isFreespace,
  } = resource as unknown as IBooking;

  // 予約タイプの判定と修正
  let bookingType = resource.booking_type;
  if (bookingRequestStatus != "not_process" && bookingType == "request") {
    bookingType = "normal";
  }

  // 拡張プロパティの設定
  const extendedProps = {
    reservationId,
    staffId,
    customerId,
    customerName,
    customerNameKana,
    customerStatus,
    customerStatusDisplayName,
    medicalMenuId,
    medicalMenuCategoryId,
    medicalMenuName,
    medicalOptionIds,
    bookingTotalAmount,
    status,
    statusName,
    note,
    note_symptom,
    bookingType,
    bookingSource,
    hotpepperConfirmed,
    bookingRequestStatus,
    specialNotes,
    additionalFees,
    medicalOptionNames,
    staff,
    medicalMenu: medical_menu,
    additionalMenus: additional_menus,
    bookingRequestId,
    roomId,
    room,
    isFreespace,
  } as IBookingEventInputExtendedProps;

  // リソースIDの生成（フリー予約、自由予約、通常予約で分岐）
  let resourceId;
  if (isFree) {
    resourceId = `${eval(get(resourceFieldName))}fb`; // fb = free booking
  } else if (isFreespace) {
    resourceId = `${eval(get(resourceFieldName))}fs`; // fs = free space
  } else {
    resourceId = `${eval(get(resourceFieldName))}`;
  }

  return {
    id: `${reservationId}`,
    resourceId: resourceId,
    start: TimeUtils.toLocalTime(start_time.toString()),
    end: TimeUtils.toLocalTime(end_time.toString()),
    extendedProps,
  } as IBookingEventInput;
};

/**
 * メニューイベントデータをFullCalendar用に変換
 * @param resource メニューデータ
 * @returns FullCalendar用イベントデータ
 */
const onMenuEventTransformFn = (resource: EventInput): EventInput => {
  // メニューデータから必要なプロパティを抽出
  const {
    id: medicalMenuId,
    week_id: weekId,
    resource_id: resourceId,
    booking_ids: reservationId,
    bookings_count: bookingsCount,
    bookings_total_amount: bookingTotalAmount,
    staff_ids: staffId,
    description,
    time_unit: timeUnit,
    unit_price: unitPrice,
    name: medicalMenuName,
    medical_option_ids: medicalOptionIds,
    bookings,
    start_time,
    end_time,
  } = resource as unknown as IMenu;

  // 拡張プロパティの設定
  const extendedProps = {
    reservationId,
    staffId,
    medicalMenuId,
    medicalMenuName,
    medicalOptionIds,
    bookingTotalAmount,
    bookingsCount,
    description,
    timeUnit,
    unitPrice,
    bookings,
  };
  return {
    id: weekId,
    resourceId: resourceId,
    start: TimeUtils.toLocalTime((start_time || "").toString()),
    end: TimeUtils.toLocalTime((end_time || "").toString()),
    extendedProps,
  } as EventInput;
};

/**
 * 個別の予約からイベントを作成する関数（メニューと予約の組み合わせ用）
 */
const onIndividualBookingEventTransformFn = (menu: IMenu, booking: IBooking): EventInput => {
  const {
    id: medicalMenuId,
    resource_id: resourceId,
    staff_ids: staffId,
    description,
    time_unit: timeUnit,
    unit_price: unitPrice,
    name: medicalMenuName,
    medical_option_ids: medicalOptionIds,
  } = menu;

  // 個別の予約IDを生成
  const individualBookingId = `${resourceId}_${medicalMenuId}_${moment(booking.start_time).format("DDMMYYYY")}_${
    booking.id
  }`;

  // リソースIDの生成（フリー予約、自由予約、通常予約で分岐）
  let finalResourceId;
  if (booking.is_free) {
    finalResourceId = `${resourceId}fb`; // fb = free booking
  } else if (booking.is_free_space) {
    finalResourceId = `${resourceId}fs`; // fs = free space
  } else {
    finalResourceId = resourceId;
  }

  // 拡張プロパティの設定
  const extendedProps = {
    reservationId: booking.id,
    staffId,
    medicalMenuId,
    medicalMenuName,
    medicalOptionIds,
    bookingTotalAmount: booking.total_amount,
    bookingsCount: 1,
    description,
    timeUnit,
    unitPrice,
    bookings: [booking],
    // 背景色計算に必要なプロパティ
    status: booking.status,
    bookingType: booking.booking_type,
    bookingSource: booking.booking_source,
    hotpepperConfirmed: booking.hotpepper_confirmed,
    // 自由予約識別用プロパティ
    isFree: booking.is_free,
    isFreespace: booking.is_free_space,
  };

  return {
    id: individualBookingId,
    resourceId: finalResourceId,
    start: TimeUtils.toLocalTime(booking.start_time.toString()),
    end: TimeUtils.toLocalTime(booking.end_time.toString()),
    extendedProps,
  } as EventInput;
};

/**
 * カレンダーリソース名（スタッフ/メニュー）を取得
 */
const resourceFieldName = computed(
  (): string => BookingResourceFieldNameEnum[get(viewType) as keyof typeof BookingResourceFieldNameEnum]
);

/**
 * 初回ロード判定フラグ
 */
const isInitialLoading = ref(false);

/**
 * sessionStorageのキー
 */
const BOOKING_CALENDAR_LOADED_KEY = "booking_calendar_loaded";

/**
 * 初期化処理
 */
const loadInitComponents = async () => {
  await setClinicId();
};

/**
 * 残り予約枠の再取得
 */
const reFetchRemainningSlot = () => {
  if (get(shownPage) == BookingViewPageTypeEnum.StaffCalendar) {
    get(staffBookingCalendar)?.reFetchRemainningSlot();
    return;
  }
  if (get(shownPage) == BookingViewPageTypeEnum.RoomCalendar) {
    get(roomBookingCalendar)?.fetchRemainingSlots();
    return;
  }
};

/**
 * カレンダーリソース取得時のコールバック
 * @param param0 viewType, start, onSuccess, showFreeSpace
 */
const onResourcesFn = async ({
  viewType: newViewType,
  start,
  onSuccess,
  showFreeSpace,
}: IBookingResourceEvent & { showFreeSpace?: boolean }) => {
  set(viewType, newViewType);
  setStartTime(start);

  await setClinicId();
  await loadStaffResources(moment(start), showFreeSpace);

  const resources = get(bookingResources);

  if (!onSuccess) return resources;

  return onSuccess(resources);
};

/**
 * 予約イベント一覧を取得
 * @param params 検索パラメータ
 * @returns FullCalendar用イベント配列
 */
const loadBookingEvents = async (params: ApiBookingIndexReq): Promise<EventInput[]> => {
  const { data } = (await BookingServices.getBookings(params)) as unknown as AxiosResponse<ApiBookingIndexRes>;
  const { bookings } = get(data);
  return get(useArrayMap(bookings, booking => onBookingEventTransformFn(booking as unknown as EventInput)));
};

/**
 * メニューイベント一覧を取得
 * @param params 検索パラメータ
 * @returns FullCalendar用イベント配列
 */
const loadMenuEvents = async (params: ApiBookingIndexReq): Promise<EventInput[]> => {
  const { data } = (await MenuServices.getBookingMenus(params)) as unknown as AxiosResponse<ApiMenuIndexRes>;
  const { menus } = get(data);

  // メニューから予約データを平坦化
  const bookings = _.flatten(get(useArrayMap(menus, menu => menu?.bookings)));

  // 日付ごとに予約をグループ化
  const bookingsByDate = _.groupBy(bookings, booking => moment(booking?.start_time).format("D"));
  let totalCustomersBookedByDate: { [key: string]: number } = {};

  // 日付ごとの予約件数を計算
  _.forOwn(bookingsByDate, (bookings, date) => {
    totalCustomersBookedByDate[date] = bookings.length;
  });

  // カレンダーに顧客数を設定
  get(staffBookingCalendar)?.setTotalCustomersBooked(totalCustomersBookedByDate);

  // 個別の予約ごとにイベントを作成
  const individualBookingEvents = _.flatten(
    get(
      useArrayMap(menus, menu =>
        get(useArrayMap(menu?.bookings || [], booking => onIndividualBookingEventTransformFn(menu, booking)))
      )
    )
  );

  return individualBookingEvents;
};

/**
 * 予約データのエクスポート処理
 * @param event クリックイベント
 * @param pickedDate 対象日付
 * @param bookingParamsFn パラメータ生成関数
 */
const onExportFn = async (event: MouseEvent, pickedDate: { start: Date }, bookingParamsFn: AnyFn) => {
  const { start } = pickedDate;
  let startDate = moment(start).format("DD-MM-YYYY");
  let endDate = moment(start).format("DD-MM-YYYY");

  // 週表示の場合は終了日を6日後に設定
  if (get(viewType) == BookingViewTypeEnum.Week) {
    endDate = moment(start).add(6, "days").format("DD-MM-YYYY");
  }

  // エクスポート用パラメータを構築
  const params = {
    ...(await bookingParamsFn({ start: startDate, end: endDate })),
    clinic_id: get(await get(clinicId)),
  };

  // ボタンを無効化して重複クリックを防止
  const button = event.currentTarget as HTMLButtonElement;
  button.classList.add("p-disabled");

  // エクスポート実行
  const { data } = await BookingServices.exportBookings(params);
  window.open(data.value, "_blank");

  // ボタンを再有効化
  button.classList.remove("p-disabled");
};

/**
 * カレンダーイベント取得時のコールバック
 * @param param0 onSuccess, pickedDate
 * @param bookingParamsFn パラメータ生成関数
 * @returns FullCalendar用イベント配列
 */
const onEventFn = async ({ onSuccess, start }: IBookingEventFn, bookingParamsFn: AnyFn): Promise<EventInput[]> => {
  let startDate = moment(start).format("DD-MM-YYYY");
  let endDate = startDate;
  const paramsQuery = route.query;
  const paramsStartTime = paramsQuery["start_time"];

  // 予約パラメータを取得
  let bookingParams = await bookingParamsFn({ start: startDate, end: endDate });
  const isWeekType = bookingParams.view_type == BookingViewTypeEnum.Week;

  // 週表示の場合は終了日を6日後に設定
  if (isWeekType) {
    bookingParams.end_time = moment(start).add(6, "days").format("DD-MM-YYYY");
  }

  // 検索パラメータを構築
  let params = {
    ...bookingParams,
    clinic_id: get(await get(clinicId)),
    canceled_by_customer_request: false,
  };

  // URLパラメータに開始時間が指定されている場合は追加
  if (paramsStartTime) {
    params["start_time"] = paramsStartTime;
  }

  // 週表示の場合はメニューイベント、それ以外は予約イベントを取得
  const resources = isWeekType ? await loadMenuEvents(params) : await loadBookingEvents(params);
  if (!onSuccess) return resources;

  return onSuccess(resources);
};

/**
 * サイドバー表示/非表示のprovide
 */
provide("onShowBookingSidebar", onShowBookingSidebar);
provide("onHideBookingSidebar", onHideBookingSidebar);

/**
 * ページ切り替え処理
 * @param view_page 表示ページ種別
 */
const onShowPage = (view_page: BookingViewPageTypeEnum) => {
  set(shownPage, view_page);
  const query = { view_page };
  router.replace({ query });
};

onBeforeMount(async () => {
  // 初回ロード判定: sessionStorageにキーがない場合は初回アクセス
  const isFirstLoad = !sessionStorage.getItem(BOOKING_CALENDAR_LOADED_KEY);

  if (isFirstLoad) {
    // 初回アクセス時の処理
    set(isInitialLoading, true);

    // 3秒後にリロード
    setTimeout(() => {
      sessionStorage.setItem(BOOKING_CALENDAR_LOADED_KEY, "true");
      location.reload();
    }, 3000);

    // 初回ロード時は以降の処理をスキップ
    return;
  }

  // 2回目以降の通常処理
  // 初期化処理を実行
  await loadInitComponents();

  // ルートクエリから表示ページを設定（デフォルトはスタッフカレンダー）
  set(shownPage, route.query.view_page || BookingViewPageTypeEnum.StaffCalendar);

  // 予約設定を取得
  let bookingSettings: any;
  await BookingSettingService.getBookingSetting(
    get(await get(clinicId)),
    (response: any) => {
      bookingSettings = response;
    },
    () => {
      // do nothing
    }
  );

  // 予約枠の時間単位を設定（例: 15分 → "00:15:00"）
  slotDuration.value = moment().startOf("day").add(bookingSettings?.booking_duration, "minutes").format("HH:mm:00");

  // 予約設定をストアに保存
  store.commit("bookingSetting/setBookingSetting", bookingSettings);
});

/**
 * ルートクエリパラメータの変更を監視し、ページ表示を更新する
 */
watch(
  () => route.query.view_page,
  view_page => set(shownPage, view_page)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isInitialLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          class: _normalizeClass(["cursor-pointer", { 'handle-click': shownPage.value == _unref(BookingViewPageTypeEnum).StaffCalendar }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onShowPage(_unref(BookingViewPageTypeEnum).StaffCalendar)))
        }, "予約カレンダー ", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["ml-5 cursor-pointer", { 'handle-click': shownPage.value == _unref(BookingViewPageTypeEnum).RoomCalendar }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onShowPage(_unref(BookingViewPageTypeEnum).RoomCalendar)))
        }, "部屋・設備予約 ", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["ml-5 cursor-pointer", { 'handle-click': shownPage.value == _unref(BookingViewPageTypeEnum).List }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onShowPage(_unref(BookingViewPageTypeEnum).List)))
        }, "予約一覧 ", 2)
      ]),
      (shownPage.value == _unref(BookingViewPageTypeEnum).StaffCalendar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(StaffBookingCalendar, {
                ref_key: "staffBookingCalendar",
                ref: staffBookingCalendar,
                clinicId: _unref(get)(clinicId.value),
                resourcesCount: bookingResourcesCount.value,
                toast: _unref(toast),
                slotDuration: slotDuration.value,
                onResourcesFn: onResourcesFn,
                onEventsFn: onEventFn,
                onExportFn: onExportFn,
                onShowDialogStaffTimeOff: showDialogStaffTimeOff
              }, null, 8, ["clinicId", "resourcesCount", "toast", "slotDuration"])
            ])
          ]))
        : _createCommentVNode("", true),
      (shownPage.value == _unref(BookingViewPageTypeEnum).RoomCalendar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(RoomBookingCalendar, {
              ref_key: "roomBookingCalendar",
              ref: roomBookingCalendar,
              slotDuration: slotDuration.value,
              onShowBookingSideBar: onShowBookingSidebar,
              toast: _unref(toast)
            }, null, 8, ["slotDuration", "toast"])
          ]))
        : _createCommentVNode("", true),
      (shownPage.value == _unref(BookingViewPageTypeEnum).List)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_unref(get)(clinicId.value))
              ? (_openBlock(), _createBlock(ListBookingHistory, {
                  key: 0,
                  ref_key: "listBookingHistory",
                  ref: listBookingHistory
                }, null, 512))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(BookingSidebar, {
          ref_key: "showBookingSidebar",
          ref: showBookingSidebar,
          toast: _unref(toast),
          viewType: viewType.value,
          onReloadListBookingHistory: onReloadListBookingHistory,
          reFetchRemainningSlot: reFetchRemainningSlot
        }, null, 8, ["toast", "viewType"])
      ])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" }),
    _createVNode(DialogStaffTimeOff, {
      onRefetchCalendarResources: refetchCalendarResources,
      onReFetchRemainningSlot: reFetchRemainningSlot,
      ref_key: "dialogStaffTimeOff",
      ref: dialogStaffTimeOff
    }, null, 512)
  ], 64))
}
}

})